// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class Document  {
    _originalTypeClassName = "Loom.BO.Document";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
Document.translate = translateService;
}
this.Id = null;
this.Name = null;
this.Description = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Name:any;
Description:any;
File:any;
ProjectContract:any;
static setFile = ($this, value) => {
var oldValue = $this.File;
$this.File = value;
if (value != null) {
}
}
static setProjectContract = ($this, value) => {
var oldValue = $this.ProjectContract;
$this.ProjectContract = value;
if (value != null) {
if (oldValue != null) {
Domain.ProjectContract.removeDocuments(oldValue, $this);
}
Domain.ProjectContract.addDocuments(value, $this);
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}